export default "__VITE_ASSET__DgadVbH1__"